module.exports = __webpack_public_path__ + "img/1497323515.0479c1a0.jpg";